/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import { React, useFlux, css, styled } from 'fierry/react.old';

import Navigation from 'shared/client/navigation';
import Theme from 'galax/react/map/util/theme';

import * as Layout from 'fierry/react.old/layout';


const Container = styled(Layout.Stacked)`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;


const ZoneCenter = styled(Theme)`
  transform: translate(50%, 50%);
`;


const GalaxyComponent = ({ GalaxyLayer, ...props }) =>
(
  <svg>

    <ZoneCenter {...props} user = {props.currentUser} >
      <GalaxyLayer {...props} />
    </ZoneCenter>

  </svg>
);


const getGalaxyProps = ({ zoom, ...props }, navigation) =>
{
  const { currentZone: zone, currentLocation: location } = props;

  const geometry = zone.getPlanet().getGeometry(zoom);

  return { ...props, ...navigation.getLocationInfo(zone), zone, location, currentUser: location.getUser(), geometry };
};


const Galaxy = (props) =>
{
  const [ navigation ] = useFlux(Navigation);

  return <GalaxyComponent {...getGalaxyProps(props, navigation)} />;
}


export default ({ OverlayLayer, className, width, height, zoom, ...props }) =>
(
  <Container className = {className} width = {width} height = {height} >

    <Galaxy {...props} zoom = {zoom} />

    <Layout.Overlay>
      <OverlayLayer {...props} />
    </Layout.Overlay>

  </Container>
)
